var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"chevronRight"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"chevronRight","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("polygon",{"id":"›","fill":"#000000","fillRule":"nonzero","points":"12 9.96551724 7.79310345 15 6 13.8045977 9.01149425 9 6 4.2183908 7.79310345 3 12 8.05747126"}))]);
}

ChevronRight.defaultProps = {"width":"18px","height":"18px","viewBox":"0 0 18 18","version":"1.1"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;



// WEBPACK FOOTER //
// ./src/icons/chevronRight.svg